export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyAOVeB5odz6eUgqXKJx3ENK_30wXH0dzU4",
  authDomain: "survey-check.firebaseapp.com",
  databaseURL: "https://survey-check.firebaseio.com",
  projectId: "survey-check",
  storageBucket: "survey-check.appspot.com",
  messagingSenderId: "551413778100"
};
